import React from 'react';
import { gu2px, useTheme } from '@uds/theme-utils';
import { Layout } from 'domain/constants/layout';
import Colorway from '@uds/colorway';

import Tile, { TileProps } from './Tile';
import getClassNames from './Tiles.stylesheet';

interface OuterProps {
  tiles: Array<TileProps>;
  hBaseline: number;
  layout: Layout;
}

const tileAnimation = (spacing: number) => `@keyframes arrowAnimation {
  from {
    right: ${gu2px(3, spacing)}px;
    opacity: 0.1;
  }
  to {
    right: ${gu2px(0, spacing)}px;
    opacity: 1;
  }
}`;

declare const i: number;
declare const tile: TileProps;

export const PureTiles = ({ tiles, hBaseline, layout }: OuterProps) => {
  const { theme } = useTheme();
  const classNames = getClassNames();
  return (
    <div className={classNames.root} id="test-id">
      <style>{tileAnimation(theme.spacing)}</style>
      <For each="tile" of={tiles} index="i">
        <Colorway colorway={tile.colorway} className={classNames.tile} key={i}>
          <Tile key={i} {...tile} hBaseline={hBaseline} layout={layout} leftTile={i === 0} rightTile={i === 1} />
        </Colorway>
      </For>
    </div>
  );
};

PureTiles.displayName = 'Tiles';

export default PureTiles;
